export default __webpack_public_path__ + "static/media/gallery_00.4f2716d6.jpg";